import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

// Form value pickup
// component: 'select'
// value: data-value
// Have to convert numeric value from string manually

const getOptionFromValue = (options, value) => {
  return options.find((o) => o.value === value)
    ? options.find((o) => o.value === value)
    : '';
};

function SelectControlled({
  label,
  error,
  helperText,
  placeholder,
  name,
  value,
  options,
  onChange,
  searchable,
  hideValueOnDisabled,
  ...restProps
}) {
  const handleValueChange = (e, newValue) => {
    const { value: valueFromNewValue = '' } = newValue;
    onChange(valueFromNewValue);
  };

  return (
    <Autocomplete
      value={getOptionFromValue(options, value)}
      onChange={handleValueChange}
      options={options}
      getOptionLabel={(option) => (option.label ? option.label : '')}
      getOptionDisabled={(option) => option.disable}
      renderInput={({ inputProps, ...params }) => (
        <TextField
          {...params}
          label={label}
          fullWidth
          error={error}
          helperText={helperText}
          placeholder={placeholder}
          name={name && name.trim() !== '' ? name : null}
          inputProps={Object.assign({}, inputProps, {
            'data-value': value,
            'data-component': 'select',
            readOnly: searchable ? null : 'readonly',
            'data-hidevalueondisabled': hideValueOnDisabled ? true : null,
          })}
        />
      )}
      {...restProps}
    />
  );
}

SelectControlled.defaultProps = {
  label: '',
  helperText: '',
  placeholder: '',
  error: false,
  name: '',
  searchable: false,
  popupIcon: <ArrowDropDownIcon />,
};

SelectControlled.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    ),
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  searchable: PropTypes.bool,
  popupIcon: PropTypes.element,
  hideValueOnDisabled: PropTypes.bool,
};

export default SelectControlled;
